const classNameArray = [ 'A1', 'A2', 'B1', 'B2', 'C1', 'C2' ];
const classNameArrayDetailed = [
  'A1', 'A1+', 'A2-',
  'A2', 'A2+', 'B1-',
  'B1', 'B1+', 'B2-',
  'B2', 'B2+', 'C1-',
  'C1', 'C1+', 'C2-',
  'C2'
];
const scoreMin = 0;
const scoreMax = 5;

function convertCefrScoreToClassIdx(score, numClasses) {
  let scoreOffset = scoreMin;
  let scoreRange = scoreMax - scoreMin;
  let scoreStep = scoreRange / (numClasses - 1);
  let classIdx;
  for (classIdx = 0; classIdx < (numClasses - 1); classIdx++) {
    let scoreCurrent = scoreOffset + scoreStep * classIdx;
    let scoreNext = scoreOffset + scoreStep * (classIdx + 1);
    let scoreClassThreshold = (scoreCurrent + scoreNext) / 2;
    if (score < scoreClassThreshold) {
      return classIdx;
    }
  }
  return classIdx;
}

export default {
  classNameArray: classNameArray,
  numClasses: classNameArray.length,
  numClassesDetailed: classNameArrayDetailed.length,
  scoreMin: scoreMin,
  scoreMax: scoreMax,
  convertCefrScoreToClass(score) {
    return classNameArray[convertCefrScoreToClassIdx(score, this.numClasses)];
  },
  convertCefrScoreToClassDetailed(score) {
    return classNameArrayDetailed[convertCefrScoreToClassIdx(score, this.numClassesDetailed)];
  },
};
